
<div class="flex items-center justify-between mt-6 w-full px-5 my-4">
    <button (click)="p.previous()" [disabled]="p.isFirstPage() || p.pages.length==0" [ngClass]="{'bg-primary-700 hover:bg-primary-100 dark:text-orange text-medium_purple':!p.isFirstPage()}" class="flex items-center  px-2 py-1 md:px-5 md:py-2  text-xs md:text-sm text-gray font-medium capitalize transition-colors duration-200  border rounded-md gap-x-2 ">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 rtl:-scale-x-100">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
        </svg>

        <span class="hidden md:flex">
            Anterior
        </span>
    </button>

    <div class="items-center hidden md:flex gap-x-3">
        <ng-container  >
            <a  *ngFor="let page of p.pages;"  (click)="p.setCurrent(page.value)" [ngClass]="{' bg-primary-800 font-bold text-orange':p.getCurrent() === page.value}" class="cursor-pointer px-2 py-1 text-sm text-gray  font-medium rounded-md ">{{page.label}}</a>
       
   
        </ng-container>
       
        
    </div>

    <button (click)="p.next()" [disabled]="p.isLastPage() || p.pages.length==0" [ngClass]="{'bg-primary-700 hover:bg-primary-100 dark:text-orange text-medium_purple':!p.isLastPage() && p.pages.length>0}" class="flex items-center px-2 py-1 md:px-5 md:py-2 text-xs md:text-sm text-gray font-medium capitalize transition-colors duration-200  border rounded-md gap-x-2 ">
        <span class="hidden md:flex">
            Siguiente
        </span>

        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 rtl:-scale-x-100">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
        </svg>
    </button>
</div> 
